import { Container, Row, Col, Card } from 'react-bootstrap';
import { useState } from 'react';

const Signup = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    concerts: true,
    news: true
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const isFormValid = () => {
    return formData.name.trim() !== '' && 
           formData.email.trim() !== '' && 
           (formData.concerts || formData.news);
  };

  return (
    <Container>
      <h1 className="mb-4 text-white">Join Our Mailing List</h1>
      
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="bg-dark text-white">
            <Card.Body className="p-4">
              <style>
                {`
                  .ml-form-fieldRow input::placeholder {
                    color: #6c757d !important;
                    opacity: 1 !important;
                  }
                  .ml-form-fieldRow input::-webkit-input-placeholder {
                    color: #6c757d !important;
                    opacity: 1 !important;
                  }
                  .ml-form-fieldRow input::-moz-placeholder {
                    color: #6c757d !important;
                    opacity: 1 !important;
                  }
                  .ml-form-fieldRow input:-ms-input-placeholder {
                    color: #6c757d !important;
                    opacity: 1 !important;
                  }
                  .ml-form-fieldRow input:-moz-placeholder {
                    color: #6c757d !important;
                    opacity: 1 !important;
                  }
                `}
              </style>
              
              <div id="mlb2-29961220" className="ml-form-embedContainer ml-subscribe-form ml-subscribe-form-29961220">
                <div className="ml-form-align-center">
                  <div className="ml-form-embedWrapper embedForm">
                    <div className="ml-form-embedBody ml-form-embedBodyDefault row-form">
                      <div className="ml-form-embedContent mb-4">
                        <h4 className="text-white mb-2">Signup</h4>
                        <p className="text-white mb-0">Subscribe to be first to hear about upcoming concerts and events</p>
                      </div>

                      <form className="ml-block-form" action="https://assets.mailerlite.com/jsonp/1749392/forms/163521790287546320/subscribe" method="post" onSubmit={(e) => {
                        e.preventDefault();
                        const formData = new FormData(e.currentTarget);
                        fetch(e.currentTarget.action, {
                          method: 'POST',
                          body: formData
                        })
                        .then(response => response.json())
                        .then(data => {
                          if (data.success) {
                            const formElement = document.querySelector('.row-form') as HTMLElement;
                            const successElement = document.querySelector('.row-success') as HTMLElement;
                            if (formElement && successElement) {
                              formElement.style.display = 'none';
                              successElement.style.display = 'block';
                            }
                          }
                        })
                        .catch(error => {
                          console.error('Error:', error);
                        });
                      }}>
                        <div className="ml-form-formContent">
                          <div className="ml-form-fieldRow mb-3">
                            <div className="ml-field-group ml-field-name">
                              <input 
                                aria-label="name" 
                                type="text" 
                                className="form-control bg-dark text-white border-secondary" 
                                name="name" 
                                placeholder="Enter your name" 
                                autoComplete="given-name"
                                required
                                value={formData.name}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          
                          <div className="ml-form-fieldRow ml-last-item mb-4">
                            <div className="ml-field-group ml-field-email ml-validate-email ml-validate-required">
                              <input 
                                aria-label="email" 
                                aria-required="true" 
                                type="email" 
                                className="form-control bg-dark text-white border-secondary" 
                                name="email" 
                                placeholder="Enter your email address" 
                                autoComplete="email"
                                required
                                value={formData.email}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="ml-form-interestGroupsRow ml-block-groups ml-validate-required mb-4">
                          <h6 className="text-white mb-3">What would you like to receive?</h6>
                          
                          <div className="ml-form-interestGroupsRowCheckbox group mb-3">
                            <div className="d-flex align-items-start">
                              <input 
                                type="checkbox" 
                                name="concerts" 
                                value="163520642798323023" 
                                className="mt-1 me-3"
                                id="concerts-checkbox"
                                checked={formData.concerts}
                                onChange={handleInputChange}
                              />
                              <label htmlFor="concerts-checkbox" className="text-white mb-0 d-flex align-items-center">
                                <div className="label-description text-white">Concerts and Events</div>
                              </label>
                            </div>
                          </div>
                          
                          <div className="ml-form-interestGroupsRowCheckbox last-group">
                            <div className="d-flex align-items-start">
                              <input 
                                type="checkbox" 
                                name="news" 
                                value="163521726741742904" 
                                className="mt-1 me-3"
                                id="news-checkbox"
                                checked={formData.news}
                                onChange={handleInputChange}
                              />
                              <label htmlFor="news-checkbox" className="text-white mb-0 d-flex align-items-center">
                                <div className="label-description text-white">Latest Band News</div>
                              </label>
                            </div>
                          </div>
                        </div>

                        <input type="hidden" name="ml-submit" value="1" />
                        <input type="hidden" name="anticsrf" value="true" />
                        <input type="hidden" name="fields[name]" value={formData.name} />
                        <input type="hidden" name="fields[email]" value={formData.email} />
                        <input type="hidden" name="groups[]" value={formData.concerts ? "163520642798323023" : ""} />
                        <input type="hidden" name="groups[]" value={formData.news ? "163521726741742904" : ""} />

                        <div className="ml-form-embedSubmit">
                          <button 
                            type="submit" 
                            className="btn btn-primary w-100" 
                            disabled={!isFormValid()}
                          >
                            Subscribe to Mailing List
                          </button>
                        </div>
                      </form>
                    </div>

                    <div className="ml-form-successBody row-success" style={{ display: 'none' }}>
                      <div className="ml-form-successContent">
                        <h4 className="text-white">Thank you!</h4>
                        <p className="text-white">You have successfully joined our subscriber list.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Signup;
